// @ts-nocheck
import { EventData } from "@/types/events";
import { SubSection, FieldLabel } from "./SectionWrapper";
import WysiwygEditor from "@/components/ui/wysiwyg-editor";
import { StayToPlaySubsection } from "./StayToPlaySubsection";


interface Props {
  event: EventData;
  updateEvent: (updates: Partial<EventData>) => void;
}

export function HotelsSection({ event, updateEvent }: Props) {
  return (
    <div className="space-y-6">
      <SubSection title="Hotel Information">
        <div>
          <FieldLabel>Hotel Information</FieldLabel>
          <WysiwygEditor
            value={event.hotels_info || ""}
            onChange={(v) => updateEvent({ hotels_info: v })}
            placeholder="General hotel information for attendees..."
          />
          <p className="text-xs text-muted-foreground mt-1">
            General info about hotels for this event. Shown on the public event page in the Hotels modal. Supports formatting, lists, and links.
          </p>
        </div>
      </SubSection>
      <StayToPlaySubsection event={event} updateEvent={updateEvent} />
    </div>
  );
}
